import React from 'react'
import Hero from './Hero'
import Project from './Project'
import Skills from './Skills'

const Home = () => {
    return (
        <>
            <Hero />
            <Project />
            <Skills />
        </>
    )
}

export default Home